import axios from 'axios';

export const ARCHIVE_API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/archive`;
export const archiveConfig = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
export const archiveApi = {
  get: (path, params) => axios.get(`${ARCHIVE_API}${path}`, { ...archiveConfig(), params }),
  post: (path, data = {}) => axios.post(`${ARCHIVE_API}${path}`, data, archiveConfig()),
};
export const formatBytes = bytes => {
  if (!Number.isFinite(bytes)) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes, index = 0;
  while (value >= 1024 && index < units.length - 1) { value /= 1024; index += 1; }
  return `${value.toLocaleString(undefined, { maximumFractionDigits: index ? 2 : 0 })} ${units[index]}`;
};
export const archiveError = (error, fallback) => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : fallback;
export const downloadArchive = async id => {
  const { data } = await archiveApi.post(`/snapshots/${id}/download-ticket`);
  const link = document.createElement('a');
  link.href = `${ARCHIVE_API}/download?ticket=${encodeURIComponent(data.ticket)}`;
  link.rel = 'noreferrer';
  link.referrerPolicy = 'no-referrer';
  document.body.appendChild(link);
  link.click();
  link.remove();
};